import script from "./ScopesProjectStats.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopesProjectStats.vue?vue&type=script&setup=true&lang=js"

import "./ScopesProjectStats.vue?vue&type=style&index=0&id=e95702fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e95702fc"]])

export default __exports__